import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateTokenExpiryStatus } from "../../redux/tokenSlice";

const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:2000/";

const useApiRequest = (
  endpoint,
  method = "GET",
  params = {},
  data = {},
  headers = {}
) => {
  const dispatch = useDispatch()
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const makeApiRequest = async () => {
    setLoading(true);
    setError(null);

    try {
      const url = `${baseURL}${endpoint}`;
      const defaultHeaders = {
        "Content-Type": "application/json",
        Authorization: "Basic " + sessionStorage.getItem("token"), // Fetch token from sessionStorage
        ...headers, // Merge custom headers passed as argument
      };

      const response = await axios({
        method,
        url,
        headers: defaultHeaders,
        params,
        data,
      });

      setResponse(response?.data);
    } catch (error) {
      setError(error);
      console.error("API Error:", error.response || error.message);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
      if(error){
        dispatch(updateTokenExpiryStatus(true))
      }
  }, [error])

  return { response, loading, error, makeApiRequest };
};

export default useApiRequest;
